import AdminSocialLinksPage from './AdminSocialLinksPage';
export default AdminSocialLinksPage;
